<div class="agent-container">
    <div class="agent-header">
        <div class="header-left">
            <img src="./assets/images/icons/dashboard/user_card_red.png" alt="user card Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Detail d'agent @if(agent){ / <strong class="username">{{ agent.firstName + " " + agent.lastName }}</strong>}</span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>
    <div class="agent-details-container">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des détails du membre...</p>
        </div>

        <!-- Error state -->
        <div *ngIf="!isLoading && errorMessage" class="error-state">
            <div class="error-icon">!</div>
            <p class="error-message">{{ errorMessage }}</p>
            <button class="retry-button" (click)="goToList()">Retour à la liste</button>
        </div>


        <div *ngIf="!isLoading && agent && !errorMessage" class="agent-card-container">
            <div class="agent-card">
                <div class="agent-image-col">
                    <img [src]="agent.profileImage || './assets/images/icons/user-default-icon.png'" [alt]="agent.firstName" class="agent-image" [class.full]="agent.profileImage" (error)="setDefaultImage($event)">
                </div>

                <div class="agent-content-col">
                    <div class="col-header">
                        <div class="left-side">
                            <h3 class="agent-title">{{ agent.firstName + " " + agent.lastName }}</h3>
                            <p class="agent-description">
                                {{ agent.phoneNumber }}
                            </p>
                            <p class="agent-description">
                                {{ agent.email }}
                            </p>
                            <p *ngIf="agent.address" class="agent-description">
                                {{ formatAddress(agent.address) }}
                            </p>

                            <div class="agent-infos">
                                <span class="agent-email">Spécialisation: <span>{{ agent.specialization }}</span></span>
                                <span class="agent-email">Âge: <span>{{ agent.age }} ans</span></span>
                                <span class="agent-email">Taille: <span> {{ agent.height }} cm</span></span>
                                <span class="agent-email">Années d'expérience: <span>{{ agent.yearsOfExperience }} ans</span></span>
                                <span *ngIf="agent.rating" class="agent-rating">
                                <div class="rating-stars">
                                    @for (star of getStars(agent.rating); track $index) {
                                    <img [src]="star" alt="star" class="star"> }
                                </div>
                                <span>{{ agent.rating }}/5</span></span>
                            </div>
                        </div>
                        <div class="right-side">
                            <div class="status-badge">
                                <span class="status-dot" [class.public]="agent.isAvailable" [class.private]="!agent.isAvailable"></span>
                                <span class="status-text">{{ agent.isAvailable ? 'Disponible' : 'Indisponible' }}</span>
                            </div>
                            <div class="status-badge">
                                <span class="status-dot" [class.public]="agent.isEnabled" [class.private]="!agent.isEnabled"></span>
                                <span class="status-text">{{ agent.isEnabled ? 'Compte activer' : 'Compte inactive' }}</span>
                            </div>
                            <div class="status-badge">
                                <span class="status-dot" [class.public]="agent.emailVerified" [class.private]="!agent.emailVerified"></span>
                                <span class="status-text">{{ agent.emailVerified ? 'Email Vérifié' : 'Email non vérifié' }}</span>
                            </div>
                            <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                                <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                            </button>
                        </div>
                    </div>

                    <div class="agent-footer">
                        <div class="creation-date">
                            a rejoint le {{ agent.createdAt }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="popup-menu" *ngIf="menuOpen">
                <div class="arrow"></div>
                <ul>
                    <li (click)="edit()">
                        <img src="./assets/images/icons/edit.png" alt="View"> Modifier
                    </li>
                    <li (click)="toggleVisibility()">
                        <img src="./assets/images/icons/eye.png" alt="Visibility"> {{ agent.isEnabled ? 'Rendre le compte inactif' : 'Rendre le compte actif' }}
                    </li>
                    <li (click)="openAvailabilityModal()">
                        <img src="./assets/images/icons/eye.png" alt="Visibility"> {{ agent.isAvailable ? "Rendre l'agent indisponible" : "Mettre l'agent à disposition" }}
                    </li>
                    <li (click)="confirmDelete()" class="delete-item">
                        <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
                    </li>
                </ul>
            </div>

            <div class="description-card">
                <h1>Bio</h1>
                <p>{{agent.bio}}</p>
            </div>

            <app-admin-agent-reservations-card [reservations]="agent.activeAssignments" [isActiveAssignments]="true"></app-admin-agent-reservations-card>
            <app-admin-agent-reservations-card [reservations]="agent.completedAssignments" [isCompletedAssignments]="true"></app-admin-agent-reservations-card>
        </div>
    </div>
</div>


<div class="confirmation-modal-overlay" *ngIf="showDeleteModal && agent">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer ce agent <br><strong>"{{ agent.firstName + " " + agent.lastName  }}"</strong> (<small>{{agent.email}}</small>) ?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteAgent()">Supprimer</button>
        </div>
    </div>
</div>

<div class="confirmation-modal-overlay" *ngIf="showAvailabilityModal && agent">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">
                {{ agent.isAvailable ? 'Rendre l’agent indisponible' : 'Rendre l’agent disponible' }}
            </h3>
            <button class="close-button" (click)="closeAvailabilityModal()">×</button>
        </div>

        <div class="modal-body">
            <p> Êtes-vous sûr de vouloir
                <strong> {{ agent.isAvailable ? 'rendre indisponible' : 'rendre disponible' }} </strong>
                <br /> l’agent
                <strong>"{{ agent.firstName }} {{ agent.lastName }}"</strong> (<small>{{ agent.email }}</small>) ?
            </p>
            <p class="info-text" *ngIf="agent.isAvailable">
                L’agent ne pourra plus être assigné à des missions.
            </p>
            <p class="info-text" *ngIf="!agent.isAvailable">
                L’agent pourra de nouveau être assigné à des missions.
            </p>
        </div>

        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeAvailabilityModal()">
                Annuler
            </button>
            <button class="confirm-btn" [ngClass]="agent.isAvailable ? 'warning' : 'success'" (click)="confirmAvailabilityChange()">
                {{ agent.isAvailable ? 'Rendre indisponible' : 'Rendre disponible' }}
            </button>
        </div>
    </div>
</div>